import { useSelector } from 'react-redux'
import styled from 'styled-components'
import Type from 'components/Type'
import Icon from 'components/Icon'
import A from 'components/A'
import Container from 'components/Container'
import TextButton from 'components/TextButton'
import Stack from '@mui/material/Stack'
import { DONDE, BUILD_ID } from 'utils/constants'
import { useAction } from 'utils/actions'

const HiddenField = styled.input`
  position: fixed;
  left: 100vw;
  top: 100vh;
  opacity: 0;
`

const Footer = () => {
  const token = useSelector(({ global }) => global.token)
  const { openTravelQuestionnaire, openChat } = useAction()

  const copyToken = () => {
    const copyText = document.getElementById('hidden-token')
    copyText.select()
    copyText.setSelectionRange(0, 99999)
    document.execCommand('copy')
  }

  return (
    <Stack
      id="footer"
      as="footer"
      sx={{
        bgcolor: 'background.darkSolid.main',
        color: 'background.darkSolid.text',
        height: 'fit-content',
        zIndex: 'footer',
        boxShadow: 'inset 0 0 4px 0 rgba(0, 0, 0, 0.5)',
      }}
    >
      <Container>
        <Stack
          pt={4.5}
          pb={3}
          gap={3}
        >
          <Stack
            display="grid"
            alignItems="flex-start"
            gap={4}
            gridTemplateColumns={{
              sm: 'repeat(4, 1fr)',
              lg: 'repeat(4, 200px)',
            }}
          >
            <Stack
              gap={2}
            >
              <A
                to="/"
                wrapComponent
              >
                <Icon
                  icon="DondeLogo"
                  height="30"
                  width="105"
                />
              </A>
              <Stack
                gap={1}
              >
                <Type
                  variant="bodySmallBold"
                  color="inverse"
                  blend={5}
                >
                  Version {BUILD_ID}
                </Type>
                <Type
                  variant="dataSmall"
                  color="inverse"
                  blend={5}
                  onClick={copyToken}
                >
                  ©{new Date().getFullYear()} Donde Inc.
                </Type>
              </Stack>
            </Stack>
            <Stack
              gap={2}
            >
              <Type
                variant="bodyLabelMedium"
              >
                Get Support
              </Type>
              <Stack
                gap={1.5}
              >
                <TextButton
                  variant="data"
                  color="inverse"
                  blend={5}
                  onClick={openChat}
                >
                  Chat
                </TextButton>
                <TextButton
                  variant="data"
                  color="inverse"
                  blend={5}
                  onClick={() => window.open(DONDE.LINKS.SUPPORT, '_blank')}
                >
                  support@godonde.com
                </TextButton>
                <TextButton
                  variant="data"
                  color="inverse"
                  blend={5}
                  // onClick={() => window.open(DONDE.NUMBERS.SUPPORT, '_blank')}
                >
                  {DONDE.NUMBERS.SUPPORT_FORMATTED}
                </TextButton>
              </Stack>
            </Stack>
            <Stack
              gap={2}
            >
              <Type
                variant="bodyLabelMedium"
              >
                Resources
              </Type>
              <Stack
                gap={1.5}
              >
                <TextButton
                  variant="data"
                  color="inverse"
                  blend={5}
                  onClick={() => openTravelQuestionnaire()}
                >
                  Travel Design Request Form
                </TextButton>
                <A
                  to="/faq/user"
                  wrapComponent
                >
                  <TextButton
                    variant="data"
                    color="inverse"
                    blend={5}
                  >
                    FAQs
                  </TextButton>
                </A>
              </Stack>
            </Stack>
            <Stack
              gap={2}
            >
              <Type
                variant="bodyLabelMedium"
              >
                Connect with Us
              </Type>
              <Stack
                gap={1.5}
              >
                <A
                  href="https://www.linkedin.com/company/d%C3%B3nde/"
                  wrapComponent
                >
                  <TextButton
                    variant="data"
                    color="inverse"
                    blend={5}
                  >
                    LinkedIn
                  </TextButton>
                </A>
                <A
                  href="https://www.instagram.com/go_donde/"
                  wrapComponent
                >
                  <TextButton
                    variant="data"
                    color="inverse"
                    blend={5}
                  >
                    Instagram
                  </TextButton>
                </A>
              </Stack>
            </Stack>
          </Stack>
          <Stack>
            <Type
              variant="dataSubAtomic"
              blend={5}
            >
              battleface Travel Insurance plans are underwritten by Spinnaker Insurance Company (an IL Corporation, NAIC# 24376), with administrative office at One Pluckemin Way, Suite 102, Bedminister, NJ 07921. Plans are offered and administered by battleface Insurance Services LLC, 45 East Lincoln Street, Columbus, OH 43215, National Producer Number 18731960 (FL License number L107363/CA License number 0M75381). Travel Retailers offering this plan may not be licensed insurance producers and cannot answer technical questions about the terms, benefits, exclusions, and conditions of this insurance or evaluate the adequacy of your existing insurance. Your Travel Retailer may be compensated for the purchase of a Plan and may provide general information about the Plans offered, including a description of the coverage and price. The purchase of this Plan is not required in order to purchase other travel products or services offered by your Travel Retailer. This is a brief description of the coverage provided under policy series RIG-1000. The Policy will contain reductions, limitations, exclusions, and termination provisions. Please refer to the Policy for complete details. If there are conflicts between the information on this site and the Policy, the Policy will govern in all cases. Not all products or coverages may be available in all jurisdictions. Non-insurance assistance services are provided by Robin Assist.
            </Type>
          </Stack>
        </Stack>
      </Container>
      <HiddenField id="hidden-token" readOnly value={token} />
    </Stack>
  )
}

export default Footer
